<template>
    <v-container grid-list-xl justify-space-between>
        <v-layout row wrap>
            <v-flex xs12>
                <v-card-title primary-title>
                    <v-container>
                        <span class="title primary--text">PTG Douloureuse</span>

                        <v-stepper v-model="step">
                            <v-stepper-header>

                                <template v-for="stepIndex in finalStep -1">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span v-bind="attrs" v-on="on">
                                                <v-stepper-step :step="stepIndex" @click="step = stepIndex">

                                                </v-stepper-step>
                                            </span>
                                            <v-divider v-if="stepIndex < finalStep -1" ></v-divider>

                                        </template>
                                        <span>{{ stepsForms[stepIndex-1].title }}</span>
                                    </v-tooltip>

                                </template>
                            </v-stepper-header>

                            <v-stepper-items>
                                <v-stepper-content v-for="(section, stepIndex) in stepsForms" :step="stepIndex + 1" :key="section.id">
                                    <h3 class="headline mb-3 text-md-center">{{ section.title}}</h3>
                                    <v-form lazy-validation>
                                        <v-container grid-list-md>
                                            <v-layout>
                                                <v-flex md6 offset-md3>
                                                    <div v-for="question in section.questions" :key="question.id" class="p-6">
                                                        <div v-if="question.type === 'label'">
                                                            <h4>{{question.label}}</h4>
                                                        </div>
                                                        <div v-if="question.type === 'checkbox' && (question.conditionalTo ? formData[section.id][question.conditionalTo] : true)">
                                                            <v-label>{{ question.label }}</v-label>
                                                            <div v-for="(option, optionIndex) in question.options" :key="optionIndex">
                                                                <v-checkbox
                                                                    :input-value="formData[section.id][question.id][optionIndex]"
                                                                    :value="option"
                                                                    @change="setInputChanged({sectionId: section.id, questionId: question.id, optionIndex, value:option})"
                                                                    hide-details
                                                                    :label="option"
                                                                ></v-checkbox>
                                                            </div>
                                                            <v-text-field
                                                                v-if="question.other"
                                                                :value="formData[section.id][question.id][question.options.length+1]"
                                                                @change="(e) => setInputChanged({sectionId: section.id, questionId: question.id, optionIndex: question.options.length+1, value:e})"
                                                                label="Autre: "
                                                            ></v-text-field>
                                                        </div>
                                                        <div v-if="question.type === 'boolean' && (question.conditionalTo ? formData[section.id][question.conditionalTo] : true)">
                                                            <v-label>{{question.label}}</v-label>
                                                            <v-radio-group
                                                                :value="formData[section.id][question.id]"
                                                                @change="(e) => setInputChanged({sectionId: section.id, questionId: question.id, value:e})"
                                                                row
                                                            >
                                                                <v-radio label="Oui" :value="true"></v-radio>
                                                                <v-radio label="Non" :value="false"></v-radio>
                                                            </v-radio-group>

                                                        </div>
                                                        <div v-if="(question.type === 'text' || question.type === 'number') && (question.conditionalTo ? formData[section.id][question.conditionalTo] : true)">
                                                            <v-text-field
                                                                :value="formData[section.id][question.id]"
                                                                :label="question.label"
                                                                :mask="question.mask"
                                                                @change="(e) => setInputChanged({sectionId: section.id, questionId: question.id, value:e})"
                                                                :type="question.type"
                                                            ></v-text-field>
                                                        </div>
                                                        <div v-if="question.type === 'textarea' && (question.conditionalTo ? formData[section.id][question.conditionalTo] : true)">
                                                            <v-textarea
                                                                :value="formData[section.id][question.id]"
                                                                @change="(e) => setInputChanged({sectionId: section.id, questionId: question.id, value:e})"
                                                                :label="question.label"
                                                            ></v-textarea>
                                                        </div>
                                                        <div v-else-if="question.type === 'radio' && (question.conditionalTo ? formData[section.id][question.conditionalTo] : true)">
                                                            <v-label>{{question.label}}</v-label>
                                                            <v-radio-group
                                                                :value="formData[section.id][question.id]"
                                                                @change="(e) => setInputChanged({sectionId: section.id, questionId: question.id, value:e})"
                                                                row
                                                            >
                                                                <v-radio
                                                                    v-for="(option, optionIndex) in question.options"
                                                                    :key="optionIndex"
                                                                    :label="option"
                                                                    :value="option"
                                                                ></v-radio>
                                                            </v-radio-group>
                                                        </div>

                                                        <div v-if="question.type === 'select' && (question.conditionalTo ? formData[section.id][question.conditionalTo] : true)">
                                                            <v-select
                                                                :value="formData[section.id][question.id]"
                                                                @change="(e) => setInputChanged({sectionId: section.id, questionId: question.id, value:e})"
                                                                :items="question.options"
                                                                :label="question.label"
                                                            ></v-select>
                                                        </div>
                                                        <div v-if="question.type === 'slider' && (question.conditionalTo ? formData[section.id][question.conditionalTo] : true)">
                                                            <v-label>{{question.label}}</v-label>
                                                            <v-slider
                                                                :value="formData[section.id][question.id]"
                                                                @change="(e) => setInputChanged({sectionId: section.id, questionId: question.id, value:e})"
                                                                :max="question.max"
                                                                :min="question.min"
                                                                :tick-labels="getSliderLabels(question.min, question.max)"
                                                                ticks
                                                            ></v-slider>
                                                        </div>
                                                        <div v-if="question.type === 'multiple' && (question.conditionalTo ? formData[section.id][question.conditionalTo] : true)">
                                                            <v-label>{{question.label}}</v-label>
                                                            <v-btn class="mx-2" small fab color="primary" text @click="addInputMultiple({sectionId: section.id, questionId: question.id})">
                                                                <v-icon>mdi-plus</v-icon>
                                                            </v-btn>
                                                            <div v-for="(option, optionIndex) in formData[section.id][question.id]" :key="optionIndex">
                                                                <div class="display-flex">
                                                                    <v-text-field
                                                                        :value="formData[section.id][question.id][optionIndex]"
                                                                        @change="(e) => setInputChanged({sectionId: section.id, questionId: question.id, optionIndex, value:e})"
                                                                    ></v-text-field>
                                                                    <v-btn class="mx-2" small fab color="error" text @click="removeInputMultiple({sectionId: section.id, questionId: question.id, optionIndex})">
                                                                        <v-icon>mdi-minus</v-icon>
                                                                    </v-btn>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-form>
                                </v-stepper-content>
                            </v-stepper-items>
                        </v-stepper>
                    </v-container>
                </v-card-title>
            </v-flex>
            <v-flex xs12>
                <v-card-actions class="absolute-bottom-right">
                    <v-btn v-if="step > 1" @click="(step > 1) ? step = step - 1 : null" class="left">
                        Précédent
                    </v-btn>
                    <v-btn color="success" @click="submit" class="right"> Suivant </v-btn>
                </v-card-actions>
            </v-flex>
        </v-layout>

    </v-container>
</template>
<script>
import {questionsForm} from "../../../data/diagnosticForm";
import {mapActions, mapMutations, mapState} from "vuex";

export default {
    data:()=> ({
        step: 1,
        stepsForms: questionsForm,
        finalStep: questionsForm.length + 1,

    }),
    created() {
        this.setSelectedMedicalCaseId(this.$route.params.medical_case_id)
        this.getMedicalCaseInfo().then(response => {
            this.initForm(response.data.medical_case.diagnostic)
        });

    },
    computed:{
        formData: {
            get() {
                return this.$store.state.diagnostics.form.data
            },
            set(value) {
                this.setFormData(value)
            }
        },
        ...mapState('diagnostics', {
            diagnosticId: state => state.form.id,
        }),
        ...mapState('medical_cases', {
            medical_case_id: state => state.selectedMedicalCase.id,
        })
    },
    methods: {
        back() {
            this.$router.back()
        },
        submit(){
            this.setFormData(this.formData)
            this.saveDiagnostic().then(response => {
                this.step = this.step + 1
                if (this.step >= this.finalStep) {
                    this.$router.replace({name: 'patient.viewMedicalCase', params: { medical_case_id: this.medical_case_id }})
                }
            }).catch(error => {
                console.log(error)
            })
        },
        getSliderLabels(min, max){
            let labels = []
            for (let i = min; i <= max; i++) {
                labels.push(i.toString())
            }
            return labels
        },
        ...mapActions('diagnostics', ['saveDiagnostic']),
        ...mapMutations('diagnostics', {
            setFormData: 'setFormData',
            initForm: 'initForm',
            setInputChanged: 'setInputChanged',
            addInputMultiple: 'addInputMultiple',
            removeInputMultiple: 'removeInputMultiple',
        }),
        ...mapMutations('medical_cases', {
            setSelectedMedicalCaseId: 'setSelectedMedicalCaseId',
        }),
        ...mapActions('medical_cases', ['getMedicalCaseInfo']),

    },

}

</script>

<style scoped>
.p-6{
    padding: 1em;
}

</style>
